import { App as AntApp, ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import { useEffect, useMemo, type ReactNode } from 'react';
import { useUiStore } from '@/app/ui-store';
import { buildTheme } from './antd-theme';

type AppApi = ReturnType<typeof AntApp.useApp>;
let api: AppApi | null = null;

/** Static access to Ant's message/modal/notification for code that runs outside React (toast, confirmModal). */
export function antApi(): AppApi {
  if (!api) throw new Error('AntdProvider is not mounted');
  return api;
}
export const hasAntApi = () => api !== null;

function Binder() {
  const app = AntApp.useApp();
  useEffect(() => { api = app; return () => { if (api === app) api = null; }; }, [app]);
  return null;
}

export function AntdProvider({ children }: { children: ReactNode }) {
  const mode = useUiStore((s) => s.theme);
  const theme = useMemo(() => buildTheme(mode), [mode]);
  return (
    <ConfigProvider theme={theme} locale={enUS} componentSize="middle">
      <AntApp message={{ maxCount: 4, duration: 3.5 }}>
        <Binder />
        {children}
      </AntApp>
    </ConfigProvider>
  );
}
